import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=4b853734&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=4b853734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b853734",
  null
  
)

export default component.exports